import { IShareLinkInfo } from "@/types/summary";
import RefreshIcon from "@/assets/common/ic_item_refresh.svg?react";
import { LinkValidPeriodType, LinkValidTextMap } from "@/constants/share";
import dayjs from "dayjs";
import { IPartialShareSettingAttr } from "@/types/share";

interface LinkValidityRefreshBtnProps {
  shareInfo?: IShareLinkInfo | null;
  disabled: boolean;
  onShareSettingChange: (newParams: IPartialShareSettingAttr) => void;
}

const LinkValidityRefreshBtn = ({
  shareInfo,
  disabled,
  onShareSettingChange,
}: LinkValidityRefreshBtnProps) => {
  const handleRefresh = () => {
    onShareSettingChange({
      linkValidity: shareInfo?.linkValidity,
    });
  };
  const showRefreshIcon = shareInfo?.linkValidity !== LinkValidPeriodType.Permanent;
  return (
    shareInfo && (
      <div className="h-5.5 lh-5.5 mt-2 w-full flex items-center justify-between">
        <div className="text-3 text-mx-tertiary">分享有效期</div>
        <div className="text-3 text-mx-secondary flex items-center">
          {`${LinkValidTextMap[shareInfo?.linkValidity]}${
            showRefreshIcon
              ? `(${dayjs(shareInfo.expiredTime).format("MM-DD HH:mm")})`
              : ''
          }`}
          {!disabled && showRefreshIcon && (
            <RefreshIcon className="ml-2" onClick={handleRefresh} />
          )}
        </div>
      </div>
    )
  );
};

export default LinkValidityRefreshBtn;
